import Segment from './segment'
import SegmentItem from './segmentItem'

Segment.Item = SegmentItem

export default Segment